var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "view-loader",
    {
      attrs: { loading: !!_vm.loading },
      scopedSlots: _vm._u([
        {
          key: "label",
          fn: function() {
            return [
              _c("h2", [_vm._v(_vm._s(_vm._f("trans")("please_wait")) + "...")])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("assign-team-search", {
        attrs: { date: _vm.date, disabled: !!_vm.disabled },
        on: {
          "update:date": function($event) {
            _vm.date = $event
          },
          request: _vm.onSearchRequest,
          response: _vm.onSearchResponse
        }
      }),
      _vm._v(" "),
      _vm.meals.length
        ? _c("assign-team-meals", {
            attrs: {
              meals: _vm.meals,
              date: _vm.date,
              disabled: !!_vm.disabled
            },
            on: {
              request: function($event) {
                _vm.loading++
              },
              response: function($event) {
                _vm.loading--
              },
              disable: _vm.onDisable
            }
          })
        : _vm.wasSearched && !_vm.loading
        ? _c("div", { staticClass: "alert alert-info" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("trans")("grid.no_data_message")) +
                "\n    "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55c2434a", { render: render, staticRenderFns: staticRenderFns })
  }
}